{
  "legalConfirmLabel": "关闭",
  "legalCopyright": "Copyright © {copyrightYears} Adobe Inc. All rights reserved.",
  "legalPrivacyPolicy": "隐私政策",
  "legalTermsOfUse": "使用条款",
  "legalTermsOfUseLink": "https://www.adobe.com/go/experiencecloudterms_cn",
  "profileLegalNoticesMenuItem": "法律声明"
}
